import Dexie, { EntityTable } from 'dexie';

interface Record {
  id: number;
  docId: string;
  recordFile: File;
  title: string;
  duration: string;
  createdAt: Date;
}

/** 진행 중 녹음 — 녹음하는 동안만 존재하고, 정상 종료되면 지운다 (PORTAL-12587) */
interface LiveSession {
  sessionId: string;
  docId: string;
  title: string;
  mimeType: string;
  startedAt: Date;
  updatedAt: Date;
}

/** 진행 중 녹음의 조각 — 순서대로 이으면 그 시점까지의 녹음 파일이 된다 */
interface LiveChunk {
  id: number;
  sessionId: string;
  seq: number;
  blob: Blob;
}

const db = new Dexie('AudioDatabase') as Dexie & {
  records: EntityTable<Record, 'id'>;
  liveSessions: EntityTable<LiveSession, 'sessionId'>;
  liveChunks: EntityTable<LiveChunk, 'id'>;
};

db.version(1).stores({
  records: '++id, docId, recordFile, title, duration, createdAt',
});

// v2 — 진행 중 녹음 중간 저장 테이블 추가. 기존 records 는 그대로 둔다 (PORTAL-12587)
db.version(2).stores({
  records: '++id, docId, recordFile, title, duration, createdAt',
  liveSessions: 'sessionId, updatedAt',
  liveChunks: '++id, sessionId',
});

export type { Record, LiveSession, LiveChunk };
export { db };
